document.addEventListener("DOMContentLoaded", function () {
    console.log("AJAX Cart Fixes Loaded");

    var miniCart = document.querySelector(".js-minicart");
    var checkoutButton = document.querySelector(".button-checkout");

    /** ✅ FUNCTION TO RESTORE CHECKBOX STATES */
    function restoreCheckboxStates() {
        var savedGiftWrap = localStorage.getItem("giftWrapSelected");
        var savedTerms = localStorage.getItem("termsAccepted");

        var termsCheckbox = document.getElementById("effectiveAppsAgreeCB");
        var giftWrapCheckbox = document.getElementById("effectiveAppsEGW");

        if (giftWrapCheckbox && savedGiftWrap === "true") {
            giftWrapCheckbox.checked = true;
        }

        if (termsCheckbox && savedTerms === "true") {
            termsCheckbox.checked = true;
        }
    }

    /** ✅ FUNCTION TO ENSURE CHECKBOXES EXIST AFTER AJAX UPDATES */
    function ensureCheckboxesExist() {
        var checkoutOptions = document.querySelector(".checkout-options");

        if (!checkoutOptions) {
            console.error("Checkout options container not found!");
            return;
        }

        // Ensure Gift Wrap Checkbox is Present
        if (!document.getElementById("effectiveAppsEGW")) {
            console.log("Re-inserting Gift Wrap checkbox...");
            var giftWrapContainer = document.createElement("div");
            giftWrapContainer.className = "gift-wrap-option";
            giftWrapContainer.innerHTML = `
                <input type="checkbox" id="effectiveAppsEGW">
                <label for="effectiveAppsEGW">
                    <span>Add a gift sleeve €1.25</span>
                    <img class="effectiveAppsEGWImage" alt="Gift icon" src="https://cdn.shopify.com/s/files/1/0395/1797/8787/t/6/assets/pink_gift_box.png">
                </label>
            `;
            checkoutOptions.appendChild(giftWrapContainer);
        }

        // Ensure Terms & Conditions Checkbox is Present BELOW Gift Wrap
        if (!document.getElementById("effectiveAppsAgreeCB")) {
            console.log("Re-inserting Terms & Conditions checkbox...");
            var termsContainer = document.createElement("div");
            termsContainer.className = "terms-conditions";
            termsContainer.innerHTML = `
                <input type="checkbox" id="effectiveAppsAgreeCB">
                <label for="effectiveAppsAgreeCB">
                    <span>I agree to the <a href="https://www.smithandsinclair.com/pages/terms-and-conditions" target="_blank">terms and conditions</a></span>
                </label>
            `;
            checkoutOptions.appendChild(termsContainer);
        }

        restoreCheckboxStates();
    }

    /** ✅ ENSURE CHECKBOXES REMAIN VISIBLE AFTER AJAX CART UPDATES */
    var observer = new MutationObserver(function () {
        console.log("Mini-cart updated - Reapplying checkboxes");
        ensureCheckboxesExist();
    });

    if (miniCart) {
        observer.observe(miniCart, { childList: true, subtree: true });
    }

    /** ✅ PREVENT CHECKOUT WITHOUT TERMS AGREEMENT */
    if (checkoutButton) {
        checkoutButton.addEventListener("click", function (event) {
            var termsCheckbox = document.getElementById("effectiveAppsAgreeCB");
            if (!termsCheckbox || !termsCheckbox.checked) {
                alert("Please agree to the terms and conditions before proceeding.");
                event.preventDefault();
                return false;
            }
            window.location.href = "/checkout";
        });
    }

    /** ✅ SAVE CHECKBOX SELECTIONS TO LOCAL STORAGE */
    document.addEventListener("change", function (event) {
        if (event.target.id === "effectiveAppsAgreeCB") {
            localStorage.setItem("termsAccepted", event.target.checked);
        }
        if (event.target.id === "effectiveAppsEGW") {
            localStorage.setItem("giftWrapSelected", event.target.checked);
        }
    });

    /** ✅ RESTORE CHECKBOX STATES ON PAGE LOAD */
    ensureCheckboxesExist();

    /** ✅ FIX BACKGROUND OVERLAY TO ENSURE THE CART ICON IS CLICKABLE */
    document.querySelector(".bg-minicart").addEventListener("click", function () {
        document.querySelector(".js-minicart").classList.remove("active");
    });

    /** ✅ FIX ALIGNMENT OF CHECKBOXES & LABELS */
    function fixAlignment() {
        var checkboxes = document.querySelectorAll(".checkout-options input[type='checkbox']");
        checkboxes.forEach(function (checkbox) {
            checkbox.style.width = "18px";
            checkbox.style.height = "18px";
            checkbox.style.marginRight = "8px";
            checkbox.style.verticalAlign = "middle";
        });

        var labels = document.querySelectorAll(".checkout-options label");
        labels.forEach(function (label) {
            label.style.display = "flex";
            label.style.alignItems = "center";
            label.style.fontSize = "16px";
            label.style.color = "#333";
        });

        var giftWrapLabel = document.querySelector(".gift-wrap-option label");
        if (giftWrapLabel) {
            giftWrapLabel.style.justifyContent = "flex-start";
        }

        var termsLabel = document.querySelector(".terms-conditions label");
        if (termsLabel) {
            termsLabel.style.justifyContent = "flex-start";
        }
    }

    setTimeout(fixAlignment, 500);
});
